import { render, staticRenderFns } from "./CheckBoxField.vue?vue&type=template&id=0fbf3c56"
import script from "./CheckBoxField.vue?vue&type=script&lang=js"
export * from "./CheckBoxField.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxField.vue?vue&type=style&index=0&id=0fbf3c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports